const EMBEDDED_DASHBOARD_PATH = /^\/embed\/dashboards\/[^/]+\/?$/;

export function isEmbeddedDashboardPath(pathname: string): boolean {
  return EMBEDDED_DASHBOARD_PATH.test(pathname);
}